import React from 'react';
import smaartLogoNavy from '../../assets/smaart-logo-navy.svg';
import smaartLogoWhite from '../../assets/smaart-logo-white.svg';

/**
 * Reusable Logo Component — renders the official SMAART INSTITUTE logo image
 * (the same asset the student dashboard sidebar uses), replacing the old
 * typed-text wordmark so branding is identical across both apps.
 *
 * Props:
 * - variant: 'light' (white logo, for dark backgrounds) | 'dark' (navy logo, for light backgrounds)
 * - size: 'sm' | 'md' | 'lg' | 'xl'
 * - withBackground: boolean (renders the logo inside a clean light badge card)
 * - className: additional classes
 */
const Logo = ({
  variant = 'light',
  size = 'md',
  withBackground = false,
  align = 'start',
  className = ''
}) => {
  const heights = {
    sm: 'h-7',
    md: 'h-9',
    lg: 'h-11',
    xl: 'h-14'
  };

  const badgeSizes = {
    sm: 'px-4 py-2',
    md: 'px-5 py-2.5',
    lg: 'px-7 py-3',
    xl: 'px-9 py-3.5'
  };

  // The badge card is always light, so it always carries the navy logo.
  const src = withBackground || variant === 'dark' ? smaartLogoNavy : smaartLogoWhite;

  const img = (
    <img
      src={src}
      alt="SMAART Institute"
      className={`${heights[size]} w-auto object-contain select-none`}
      draggable={false}
    />
  );

  if (withBackground) {
    return (
      <div
        className={`inline-flex items-center ${align === 'center' ? 'justify-center' : 'justify-start'} rounded-lg bg-white/95 border border-[#dfe8f3] shadow-[0_18px_36px_-28px_rgba(26,56,132,0.26)] ${badgeSizes[size]} ${className}`}
      >
        {img}
      </div>
    );
  }

  return (
    <div className={`${align === 'center' ? 'flex justify-center' : ''} ${className}`}>
      {img}
    </div>
  );
};

export default Logo;
